import { CANCEL_BUTTON } from '../../../shared/strings';
import type { UserJourney } from '../../../shared/types/UserJourney';
import { TEXT_CONTENT_IDS } from '../../../utils/element-ids';
import headerConfig from '../../UnifiedPaymentForm/UnifiedPaymentFormHeader/utils/headerConfig';

const {
  SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_TITLE,
  SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_BACK_BUTTON,
  SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_CANCEL_BUTTON,
} = TEXT_CONTENT_IDS;

export const generateFormConfigManagerParameters = ({
  userJourney,
  backButtonLabel = 'Back',
  onBackHandler,
  onCancelHandler,
  showBackButton,
}: {
  userJourney: UserJourney;
  backButtonLabel?: string;
  onBackHandler: () => void;
  onCancelHandler: () => void;
  showBackButton: boolean;
}) => {
  const { title: formTitle } =
    headerConfig[userJourney].CARD.agent.phoneEntry;
  return {
    title: formTitle,
    titleTestId:
      SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_TITLE,
    backActionConfig: {
      label: backButtonLabel,
      testId:
        SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_BACK_BUTTON,
      handler: onBackHandler,
    },
    secondaryActionConfig: {
      label: CANCEL_BUTTON,
      handler: onCancelHandler,
      testId:
        SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_CANCEL_BUTTON,
    },
    showBackButton,
  };
};
